import Swal from "sweetalert2";
import api from "../../services/api";

export const exportAnexosContribuyente = async (fromDate, toDate) => {
  try {
    if (!fromDate || !toDate) {
      return Swal.fire("Atención", "Debes seleccionar un rango de fechas para exportar", "warning");
    }

    const result = await Swal.fire({
      title: "CSV Crédito Fiscal (Hacienda)",
      html: `
        <p>Se generará un archivo CSV en el formato oficial del Ministerio de Hacienda para importar al F07.</p>
        <p><strong>Período:</strong> ${formatDate(fromDate)} al ${formatDate(toDate)}</p>
        <p style="color: #666; font-size: 13px;">Solo se incluirán facturas VALIDADAS de Crédito Fiscal</p>
      `,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Sí, exportar",
      cancelButtonText: "Cancelar",
      confirmButtonColor: "#28a745",
    });

    if (!result.isConfirmed) return;

    Swal.fire({
      title: "Generando CSV...",
      text: "Por favor espera",
      allowOutsideClick: false,
      didOpen: () => Swal.showLoading(),
    });

    const response = await api.post(
      "/invoices/export-anexos-contribuyente",
      { from: fromDate, to: toDate },
      { responseType: "blob" }
    );

    const blob = new Blob([response.data], { type: "text/csv;charset=utf-8;" });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    const fechaInicio = fromDate.replace(/-/g, "_");
    const fechaFin = toDate.replace(/-/g, "_");
    link.download = `anexo_contribuyente_${fechaInicio}_al_${fechaFin}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);

    Swal.fire({
      icon: "success",
      title: "¡Descarga Completa!",
      text: `anexo_contribuyente_${fechaInicio}_al_${fechaFin}.csv`,
      confirmButtonText: "Entendido",
      timer: 4000,
    });
  } catch (error) {
    console.error("Error exportando anexos contribuyente:", error);
    Swal.fire({
      icon: "error",
      title: "Error en la Exportación",
      text: error.response?.data?.message || "No se pudo completar la exportación",
      confirmButtonText: "Entendido",
    });
  }
};

const formatDate = (dateString) => {
  if (!dateString) return "";
  const [year, month, day] = dateString.split("-");
  return new Date(year, month - 1, day).toLocaleDateString("es-SV", {
    day: "2-digit", month: "2-digit", year: "numeric",
  });
};